import PropTypes from 'prop-types';

export const amountType = PropTypes.shape({
  currency: PropTypes.string,
  value: PropTypes.string,
});

export const offRampStatus = PropTypes.oneOf([
  'pending',
  'completed',
  'expired',
  'cancelled',
]);

export const offRamp = PropTypes.shape({
  id: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  tradedAmount: amountType,
  convertedAmount: amountType.isRequired,
  createdAt: PropTypes.string.isRequired,
  status: offRampStatus.isRequired,
});

export const offRampsSortProp = PropTypes.shape({
  id: PropTypes.oneOf([
    'createdAt',
    'reference',
    'tradedAmount.currency',
    'tradedAmount.value',
    'convertedAmount.value',
    'status',
  ]).isRequired,
  sortAscending: PropTypes.bool.isRequired,
});

export const offRampsTablePropTypes = {
  components: PropTypes.shape({}).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(offRamp)).isRequired,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  paginationEvents: PropTypes.func.isRequired,
  sort: offRampsSortProp.isRequired,
  totalElements: PropTypes.number.isRequired,
  windowWidth: PropTypes.number.isRequired,
};

export const paginationHelperProptypes = PropTypes.shape({
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  setPageSize: PropTypes.func.isRequired,
  totalElements: PropTypes.number.isRequired,
});
